// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","item":"Menu_item__jfaZL","button":"Menu_button__AYwvA","icon":"Menu_icon__YNNWA"};